import { isEmpty } from 'lodash'
import { ReactElement } from 'react'
import { ChartConfig, BarChart, LineChart, PieChart } from '~/design_system'
import { DataQueryResult } from '~/design_system/components/charts/ChartTypes'
import { NamedQueryFilter, ReportColumnConfig } from '~/custom_reports/types'
import { DashboardQueryItem } from '~/dashboards/common'
import { useDashboardReport } from '~/dashboards/hooks'
import { SummaryProps } from '~/design_system/components/charts/PieChart'

type ChartCardProps = {
  queryId: string
  reportKey: string
  customReportUrl?: string
  filters: NamedQueryFilter[]
  chartConfig: ChartConfig
  chart: typeof BarChart | typeof LineChart | typeof PieChart
  transformResult?: (
    data: DashboardQueryItem[],
    columns: ReportColumnConfig[],
    valueFormat: 'number' | 'currency'
  ) => { id: string | number; value: string | number }[]
  summary?: ({ data }: SummaryProps) => ReactElement<any>
}

export const ChartCard = ({
  queryId,
  reportKey,
  customReportUrl,
  filters,
  chart: ChartComponent,
  chartConfig,
  transformResult,
  summary
}: ChartCardProps) => {
  const queryData: DataQueryResult = useDashboardReport({
    id: queryId,
    queryName: reportKey,
    dashboardQueryParams: { filters },
    transformResult,
    valueFormat: chartConfig.format
  })
  return (
    <ChartComponent
      data-testid={
        chartConfig.title
          ? `chart-Card-${chartConfig.title}`
          : `chart-Card-${chartConfig.xAxisLabel} By ${chartConfig.yAxisLabel}`
      }
      reportKey={reportKey}
      customReportUrl={customReportUrl}
      chartConfig={chartConfig}
      isEmpty={(queryData.data === undefined && queryData.errorCode === 403) || isEmpty(queryData.data)}
      isError={queryData.data === undefined && queryData.errorCode === 403 ? false : queryData.isError}
      isFetching={queryData.isFetching}
      isLoading={queryData.isLoading}
      data={queryData.data}
      summary={summary}
    />
  )
}
